"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _calicoUiKit = require("@calico/calico-ui-kit");

var _ref = _react.default.createElement("div", null, "No ", _react.default.createElement("strong", null, "bucketUrl"), " was specified.");

var GcsFileViewer = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(GcsFileViewer, _React$Component);

  function GcsFileViewer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, GcsFileViewer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(GcsFileViewer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      selectedGeneSymbol: null
    };
    return _this;
  }

  (0, _createClass2.default)(GcsFileViewer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style;
      var _this$props2 = this.props,
          bucketUrl = _this$props2.bucketUrl,
          files = _this$props2.files;

      if (!bucketUrl) {
        return _ref;
      }

      var usableBucketUrl = (0, _lodash.endsWith)(bucketUrl, '/') ? bucketUrl : "".concat(bucketUrl, "/");
      return _react.default.createElement("div", {
        className: className,
        style: style
      }, files.map(function (file, f) {
        var filetype = file.filetype || (0, _lodash.last)(file.filepath.split('.'));
        var src = "".concat(usableBucketUrl).concat(file.filepath);

        if (filetype === 'pdf') {
          return _react.default.createElement(_calicoUiKit.DisplayPdf, {
            key: file.filepath,
            className: "margin-bottom-6",
            src: src,
            style: {
              minHeight: '85vh'
            }
          });
        } else if (filetype === 'gif' || filetype === 'jpg' || filetype === 'png') {
          return _react.default.createElement("img", {
            alt: "visualization",
            key: file.filepath,
            className: "figure margin-bottom-6",
            src: src,
            style: {
              display: 'block'
            }
          });
        }

        return null;
      }));
    }
  }]);
  return GcsFileViewer;
}(_react.default.Component);

GcsFileViewer.defaultProps = {
  bucketUrl: null,
  files: []
};
var _default = GcsFileViewer;
exports.default = _default;